import { ApplicationConfig, LOCALE_ID, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';

// Unico consumidor del pipe `date` hoy es Calidad (fechas tipo "4 ene") — se
// registra a nivel de app para no repetir el locale en cada uso del pipe.
registerLocaleData(localeEs);

function debeRegistrarServiceWorker(): boolean {
  if (typeof window === 'undefined') return false
  const hostLocal = new Set(['localhost', '127.0.0.1', '::1'])
  return window.isSecureContext && !hostLocal.has(window.location.hostname)
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideRouter(routes),
    { provide: LOCALE_ID, useValue: 'es' },
    provideServiceWorker('ngsw-worker.js', {
      enabled: debeRegistrarServiceWorker(),
      // Registrar de inmediato (en vez de esperar hasta 30s a que la app se
      // "estabilice") reduce la ventana en la que una reapertura offline
      // puede quedar sin un Service Worker activo tomando control de la pagina.
      registrationStrategy: 'registerImmediately',
    }),
  ],
};
